import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    StartPersonalEmailSequence as StartPersonalEmailSequenceMutation,
    StartPersonalEmailSequenceVariables,
    EmailAutomationStatusManualStartInput,
} from 'nutshell-graphql-types';

import START_PERSONAL_EMAIL_SEQUENCE from '../mutations/start-personal-email-sequence.graphql';

export const useStartPersonalEmailSequence = (): {
    startPersonalEmailSequence: (arg1: EmailAutomationStatusManualStartInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [startPersonalEmailSequence, {loading, error}] = useMutation<
        StartPersonalEmailSequenceMutation,
        StartPersonalEmailSequenceVariables
    >(START_PERSONAL_EMAIL_SEQUENCE);

    return {
        startPersonalEmailSequence: (input: EmailAutomationStatusManualStartInput) =>
            startPersonalEmailSequence({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
